import { UploadImageResponseObject } from '@routellers/types/dist/upload/upload-image.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = {
    data: FormData;
    onUploadProgress?: (progressEvent: ProgressEvent) => void;
};

type ResponseData = UploadImageResponseObject;

export const uploadAudio: ApiMethodDeclaration<ParamsData, ResponseData> = ({
    data,
    onUploadProgress,
}) => ({
    url: '/uploads/audio',
    headers: {
        'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
    method: 'POST',
    data,
});
